import { ApiConstantsInterface, apiConstants } from '../constants/api.customer-info.constants'
import Axios, { AxiosInstance } from 'axios'

import { CustomerInfoInterface } from '../interfaces/customer-info.interface'
import { CustomerInfoResultsInterface } from '../interfaces/customer-info-results.interface'

interface CustomerInfoServiceInterface {
  getCustomerInfo(): Promise<any>
  postCustomerInfo(customerInfo: CustomerInfoInterface): Promise<any>
}

class CustomerInfoService implements CustomerInfoServiceInterface {
  protected axios: AxiosInstance

  protected config: ApiConstantsInterface

  constructor(config: ApiConstantsInterface) {
    this.config = config
    this.axios = Axios.create({
      baseURL: config.baseUrl,
    })
  }

  async getCustomerInfo(): Promise<any> {
    const customerInfoResponse = await this.axios.get(this.config.getCustomerInfo)
    return customerInfoResponse.data
  }

  async postCustomerInfo(customerInfo: CustomerInfoInterface): Promise<any> {
    // Convert the object to a query string format
    const formDataQuery = Object.keys(customerInfo)
      .map((key) => key + '=' + encodeURIComponent(customerInfo[key]))
      .join('&')
    const customerInfoPostResponse = await this.axios.post(this.config.postCustomerInfo, formDataQuery)
    return customerInfoPostResponse.data
  }

  convertCustomerInfoResponse(data: any): CustomerInfoResultsInterface {
    return {
      StreetAddress: data.StreetAddress,
      StreetAddressEnabled: data.StreetAddressEnabled,
      StreetAddressRequired: data.StreetAddressRequired,
      StreetAddress2: data.StreetAddress2,
      StreetAddress2Enabled: data.StreetAddress2Enabled,
      StreetAddress2Required: data.StreetAddress2Required,
      City: data.City,
      CityEnabled: data.CityEnabled,
      CityRequired: data.CityRequired,
      StateProvince: data.StateProvince,
      StateProvinceEnabled: data.StateProvinceEnabled,
      StateProvinceRequired: data.StateProvinceRequired,
      ZipPostalCode: data.ZipPostalCode,
      ZipPostalCodeEnabled: data.ZipPostalCodeEnabled,
      ZipPostalCodeRequired: data.ZipPostalCodeRequired,
      Phone: data.Phone,
      PhoneEnabled: data.PhoneEnabled,
      PhoneRequired: data.PhoneRequired,
    }
  }
}

const customerInfoService = new CustomerInfoService(apiConstants)
export { customerInfoService }
